export default [
  {
    description: 'GED Servidor',
    path: '/ged/gedservidor',
    name: 'ged-servidor',
    component: () => import('@/views/ged/gedservidor/Index.vue'),
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Documento do Servidor',
    parent: 'ged-servidor',
    path: '/ged/gedservidor/cadastro/:id?',
    name: 'ged-servidor-create',
    component: () => import('@/views/ged/gedservidor/InclusaoEdicao.vue'),
    goesToMenu: false,
  },
];
